<script>
  import ChannelIcon from '$lib/client/shared/channel-icon.svelte';
  import { DateTime } from 'luxon';
  export let scheduled_at;
  export let channel;

  const now = DateTime.now();
  let localeDate = scheduled_at ? DateTime.fromMillis(scheduled_at) : null;
  const tomorrow = now.plus({ days: 1 }).startOf('day');
  const isTomorrow = localeDate && localeDate.hasSame(tomorrow, 'day');
  const short_format = isTomorrow ? DateTime.DATETIME_SHORT : DateTime.TIME_24_SIMPLE;
  const long_format = isTomorrow ? DateTime.DATETIME_FULL : DateTime.TIME_24_WITH_LONG_OFFSET;
  let next_on_formatted = localeDate ? localeDate.toLocaleString(short_format) : '';
  let next_on_formatted_long = localeDate ? localeDate.toLocaleString(long_format) : '';
</script>

<a
  href="/{['music', channel?.slug].filter((x) => x).join('/')}"
  title="This is next on {channel ? `the ${channel.name} channel ` : ''}at {next_on_formatted_long}"
  class="scheduled_at"
>
    <ChannelIcon {channel} />
    <span class="u-ml-tiny"> {next_on_formatted}</span>
</a>
